<template>
  <div class="form-validation-assistant">
    <button
      v-if="showSummary && hasErrors"
      type="button"
      class="form-validation-assistant__summary"
      @click="$emit('open')"
    >
      <CIcon name="cil-warning" class="form-validation-assistant__summary-icon"/>
      <span>{{ summaryText }}</span>
    </button>

    <transition name="form-validation-assistant-fade">
      <div
        v-if="visible && hasErrors"
        class="form-validation-assistant__overlay"
        role="dialog"
        aria-modal="true"
        aria-labelledby="form-validation-assistant-title"
      >
        <div class="form-validation-assistant__backdrop" @click="$emit('close')"/>
        <div class="form-validation-assistant__sheet">
          <div class="form-validation-assistant__handle"/>

          <div class="form-validation-assistant__header">
            <div>
              <div id="form-validation-assistant-title" class="form-validation-assistant__title">{{ title }}</div>
              <div class="form-validation-assistant__subtitle">{{ subtitleText }}</div>
            </div>

            <CButton
              color="light"
              size="sm"
              class="form-validation-assistant__close"
              @click="$emit('close')"
            >
              Schließen
            </CButton>
          </div>

          <div class="form-validation-assistant__list">
            <button
              v-for="error in errors"
              :key="error.id"
              type="button"
              class="form-validation-assistant__item"
              @click="$emit('select', error)"
            >
              <span class="form-validation-assistant__item-copy">{{ error.label }}</span>
              <CIcon name="cil-chevron-right" class="form-validation-assistant__item-icon"/>
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FormValidationAssistant',
  props: {
    errors: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    },
    showSummary: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: 'Zum Speichern fehlen noch Angaben'
    }
  },
  computed: {
    hasErrors () {
      return this.errors.length > 0
    },
    summaryText () {
      if (this.errors.length === 1) {
        return '1 Angabe fehlt noch'
      }

      return `${this.errors.length} Angaben fehlen noch`
    },
    subtitleText () {
      if (this.errors.length === 1) {
        return 'Tippe auf den Hinweis, um direkt zum Feld zu springen.'
      }

      return 'Tippe auf einen Hinweis, um direkt zum passenden Feld zu springen.'
    }
  }
}
</script>

<style lang="scss">
.form-validation-assistant__summary {
  align-items: center;
  appearance: none;
  background: #fff5f5;
  border: 1px solid #f3c1c1;
  border-radius: 16px;
  color: #8a2d2d;
  display: inline-flex;
  font-weight: 600;
  gap: 0.5rem;
  padding: 0.8rem 1rem;
  text-align: left;
  width: 100%;
}

.form-validation-assistant__summary-icon {
  flex: 0 0 auto;
}

.form-validation-assistant__overlay {
  inset: 0;
  position: fixed;
  z-index: 1100;
}

.form-validation-assistant__backdrop {
  background: rgba(15, 23, 42, 0.36);
  inset: 0;
  position: absolute;
}

.form-validation-assistant__sheet {
  background: #fff;
  border-radius: 22px 22px 0 0;
  bottom: 0;
  box-shadow: 0 -16px 48px rgba(15, 23, 42, 0.22);
  left: 0;
  max-height: #{'min(75vh, 42rem)'};
  overflow-y: auto;
  padding: 0.9rem 1rem 1.1rem;
  position: absolute;
  right: 0;
}

.form-validation-assistant__handle {
  background: #d8dbe0;
  border-radius: 999px;
  height: 0.35rem;
  margin: 0 auto 0.9rem;
  width: 3.4rem;
}

.form-validation-assistant__header {
  align-items: flex-start;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin-bottom: 0.9rem;
}

.form-validation-assistant__title {
  color: #1f2933;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.25;
}

.form-validation-assistant__subtitle {
  color: #6c757d;
  font-size: 0.88rem;
  line-height: 1.4;
  margin-top: 0.25rem;
}

.form-validation-assistant__close {
  white-space: nowrap;
}

.form-validation-assistant__list {
  display: grid;
  gap: 0.55rem;
}

.form-validation-assistant__item {
  align-items: center;
  appearance: none;
  background: #f8fafc;
  border: 1px solid #d8dbe0;
  border-radius: 16px;
  color: #1f2933;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  min-height: 3.35rem;
  padding: 0.8rem 0.95rem;
  text-align: left;
  transition: background-color 0.15s ease, border-color 0.15s ease;
  width: 100%;
}

.form-validation-assistant__item:hover,
.form-validation-assistant__item:focus {
  background: #eef5ff;
  border-color: #9ec5fe;
  outline: none;
}

.form-validation-assistant__item-copy {
  font-weight: 600;
  line-height: 1.35;
}

.form-validation-assistant__item-icon {
  color: #6c757d;
  flex: 0 0 auto;
}

.form-validation-assistant-fade-enter-active,
.form-validation-assistant-fade-leave-active {
  transition: opacity 0.2s ease;
}

.form-validation-assistant-fade-enter,
.form-validation-assistant-fade-leave-to {
  opacity: 0;
}

@media (min-width: 992px) {
  .form-validation-assistant__sheet {
    border-radius: 20px;
    bottom: 1.25rem;
    left: auto;
    max-height: #{'min(70vh, 34rem)'};
    max-width: 26rem;
    right: 1.25rem;
  }
}
</style>
